<template>
    <div>
        <navbar :title="text_title"></navbar>
        <div class="banben">
            <div class="img"></div>
            <p>版本：v2.3.12</p>
        </div>
        <div>
            <van-cell-group>
                <van-cell is-link title="《用户服务协议》" size="16px"/>
                <van-cell is-link title="检测新版本" size="16px"/>
            </van-cell-group>
        </div>
    </div>
</template>

<script>

import navbar from '../../components/Navbar'
import Vue from 'vue';
import { Cell, CellGroup } from 'vant';

Vue.use(Cell);
Vue.use(CellGroup);
export default {
    components:{
        navbar
    },
  data(){
    return{
      text_title:'关于我们',
    }
  },
}
</script>

<style scoped>
.banben{
    background-color: rgba(242, 242, 242, 1);
    text-align: center;
    padding-top: 70px;
    padding-bottom: 20px;
}
.img{
    background-color: #fff;
    width: 54px;
    height: 54px;
    margin: 0 auto 5px;
}
</style>


// WEBPACK FOOTER //
// src/pages/set/set.vue